import "@babel/polyfill"
import lodash from "lodash"
import Vue from "vue"
import VueLodash from "vue-lodash"
import App from "./App.vue"
import vuetify from "./plugins/vuetify"
import router from "./router"
import store from "./store"

import Vuelidate from "vuelidate"

Vue.use(VueLodash, { name: "lo", lodash: lodash })
Vue.use(Vuelidate)

Vue.config.productionTip = false

const envs = ["HMD", "PERFUMIST"]

envs.map(env => {
  Vue.prototype["$" + env] = {
    constants: Object.keys(process.env).reduce((cumul, curr) => {
      if (curr.indexOf(`VUE_APP_${env}_`) >= 0)
        cumul[curr.replace(`VUE_APP_${env}_`, "")] = process.env[curr]
      return cumul
    }, {})
  }
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app")
